<div class="sw-cms-el-config-moorl-address">
    <sw-cms-mapping-field
        v-model:config="element.config.street"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.street')"
            v-model="element.config.street.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.streetNumber"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.streetNumber')"
            v-model="element.config.streetNumber.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.zipcode"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.zipcode')"
            v-model="element.config.zipcode.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.city"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.city')"
            v-model="element.config.city.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.additionalAddressLine1"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.additionalAddressLine1')"
            v-model="element.config.additionalAddressLine1.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.additionalAddressLine2"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.additionalAddressLine2')"
            v-model="element.config.additionalAddressLine2.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.countryCode"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.countryCode')"
            v-model="element.config.countryCode.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.country"
        value-types="entity"
        entity="country"
    >
        <sw-entity-single-select
            :label="$tc('moorl-foundation.field.country')"
            entity="country"
            v-model:value="element.config.countryId.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.countryState"
        value-types="entity"
        entity="country_state"
    >
        <sw-entity-single-select
            :label="$tc('moorl-foundation.field.countryState')"
            entity="country_state"
            v-model:value="element.config.countryStateId.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.locationPlaceId"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.locationPlaceId')"
            v-model="element.config.locationPlaceId.value"
        />
    </sw-cms-mapping-field>
</div>